import React from 'react';
import { bool, object } from 'prop-types';
import { keys, map, omit } from 'ramda';
import Paper from 'material-ui/Paper';

import LoadingState from '../../../../LoadingState';
import PracticeMap from '../../../../PracticeMap';

import s from './PracticeDetails.css';


export const PracticeDetails = ({ ...props }) => {

  const { isLoadingPracticeDetails, preferences } = props;
  const { name, city, state, country, fullCountryName, address, postalCode, phone, fax, email } = props.practiceDetails;

  const renderAboutUsText = () => {
    const aboutUsText = preferences.aboutUsText;
    const html = <p id="aboutUsText" dangerouslySetInnerHTML={{__html: aboutUsText}} />;

    return (aboutUsText && preferences.showAbout ? html : false);
  };

  const renderPracticeDetails = () => {

    const renderHours = () => {
      if (props.practiceDetails.hours && preferences.showHours) {
        const hours = omit('active', props.practiceDetails.hours);

        return (
          <section className={s.vcardBlock}>
            <h4 className={s.heading}>Hours</h4>
            <ul className={s.vcardList}>
              {map(day =>
                  <li key={day} className={s.vcardListItem}>
                    <span className={s.child}>{day.substring(0,3) + ': '}</span><span className={s.child}>{hours[day]}</span>
                  </li>
                , keys(hours))}
            </ul>
          </section>
        );
      }

      return null;
    };

    if (isLoadingPracticeDetails) {
      return (
        <section className={s.container}>
          <p className={s.message}>
            Loading Practice details...
          </p>
          <LoadingState context="practiceDetails" />
        </section>
      );
    } else {
      return (
        <section className={s.container}>
          {address && city && state && country && postalCode &&
            <Paper style={{ position: 'relative', height: '300px', width: '100%', marginBottom: '30px' }}>
              <PracticeMap
                address={`${address} ${city} ${state} ${fullCountryName} ${postalCode}`}
              />
            </Paper>
          }
          <section className={s.vcardContainer}>
            <div className={s.vcard}>
              {address && city && state && country && postalCode && preferences.showAddress &&
                <address className={s.vcardBlock}>
                  <h4 className={s.heading}>Address</h4>
                  <span className={s.address}>{address}</span>
                  <span className={s.address}>{city}, {state} {postalCode}</span>
                  <span className={s.address}>{fullCountryName}</span>
                </address>
              }
              {phone && preferences.showPhone &&
                <section className={s.vcardBlock}>
                  <h4 className={s.heading}>Phone</h4>
                  <p>{phone}</p>
                </section>
              }
              {email && preferences.showEmail &&
                <section className={s.vcardBlock}>
                  <h4 className={s.heading}>Email</h4>
                  <p>{email}</p>
                </section>
              }
              {fax && preferences.showFax &&
                <section className={s.vcardBlock}>
                  <h4 className={s.heading}>Fax</h4>
                  <p>{fax}</p>
                </section>
              }
            </div>
            <div className={s.vcard}>
              {
                renderHours()
              }
            </div>
          </section>
        </section>
      );
    }

  };

  return (
    <section className={s.component}>
      {
          <h3>{name}</h3>
      }
      {preferences.aboutUsText &&
        renderAboutUsText()
      }
      {
        renderPracticeDetails()
      }
    </section>
  );

};

PracticeDetails.propTypes = {
  isLoadingPracticeDetails: bool,
  practiceDetails: object.isRequired,
  preferences: object.isRequired,
};

export default PracticeDetails;



// WEBPACK FOOTER //
// ./src/components/Pages/Login/LandingPage/PracticeDetails/PracticeDetails.js